// app/javascript/doccu_sidebar.js
// Controls collapsible sidebar state and responsiveness (Pencil node / Doccu layout)

(function () {
  function syncSidebarState () {
    try {
      const isCollapsed = localStorage.getItem('doccu_sidebar_collapsed') === 'true'
      const sidebar = document.getElementById('doccu-sidebar')
      if (!sidebar) return

      if (isCollapsed) {
        sidebar.classList.add('collapsed')
      } else {
        sidebar.classList.remove('collapsed')
      }
    } catch (e) {
      // localStorage may be disabled in private browsing
    }
  }

  // Restore state on Turbo navigation and initial DOM ready
  document.addEventListener('turbo:load', syncSidebarState)
  document.addEventListener('turbo:render', syncSidebarState)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSidebarState)
  } else {
    syncSidebarState()
  }

  // Global delegated click listener for toggle button (CSP & Turbo resilient)
  document.addEventListener('click', function (e) {
    const toggleBtn = e.target.closest('#doccu-sidebar-toggle, [data-action="toggle-sidebar"]')
    if (!toggleBtn) return

    e.preventDefault()
    e.stopPropagation()

    const sidebar = document.getElementById('doccu-sidebar')
    if (!sidebar) return

    sidebar.classList.remove('no-transition')
    const isCollapsed = sidebar.classList.toggle('collapsed')

    try {
      localStorage.setItem('doccu_sidebar_collapsed', isCollapsed ? 'true' : 'false')
    } catch (err) {
      console.warn('Failed to persist sidebar state', err)
    }
  })
})()
